import React from 'react';

const CommonForm = () => {

  const ModuleCheckbox = ({ label }) => (
    <div className="form-check">
      <input className="form-check-input" type="checkbox" value="" id={`check-${label}`} />
      <label className="form-check-label" htmlFor={`check-${label}`}>
        {label}
      </label>
    </div>
  );

  const modules = [
    'Clients',
    'Invoices',
    'Leaves',
    'Reports',
    'Projects',
    'Time Logs',
    'Holidays',  
    'Knowledge Base',
    'Knowledge Base',
    'Knowledge Base',
    'Clients',
    'Invoices',
    'Leaves',
    'Reports',
    'Projects',
    'Time Logs',
    'Holidays',
    'Knowledge Base',
    'Knowledge Base',
    'Knowledge Base',
    'Clients',
    'Invoices',
    'Leaves',
    'Reports',
    'Projects',
    'Time Logs',
    'Holidays',
    'Knowledge Base',
    'Knowledge Base',
    'Knowledge Base',
    'Clients',
    'Invoices',
    'Leaves',
    'Reports',
    'Projects',
    'Time Logs',
    'Holidays',
    'Knowledge Base',
    'Knowledge Base',
    'Knowledge Base',
    'Clients',
    'Invoices',
    'Leaves',
    'Reports',
    'Projects',
    'Time Logs',
    'Holidays',
    'Knowledge Base',
    'Knowledge Base',
    'Knowledge Base',
  ];


  const renderModuleColumns = () => {
    const numColumns = 5;
    const itemsPerColumn = Math.ceil(modules.length / numColumns);
    const columns = [];

    for (let i = 0; i < numColumns; i++) {
      const start = i * itemsPerColumn;
      const end = start + itemsPerColumn;
      const columnModules = modules.slice(start, end);

      columns.push(
        <div key={i} className="col-12 col-sm-6 col-md-2 mb-3">
          {columnModules.map((label, index) => (
            <ModuleCheckbox key={`${label}-${i}-${index}`} label={label} />
          ))}
        </div>
      );
    }
    return columns;
  };

  return (

    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3 fw-bold">Create Plan</h1>
        <a href="#dashboard" className="text-decoration-none text-secondary">
          <span className="me-2">&larr;</span>Dashboard
        </a>
      </div>

      {/* Main Form Card */}
      <div className="card shadow-sm border-0 rounded-4 p-4">
        <form>
          {/* --- Input Fields Section --- */}
          <h5 className="fw-bold mb-4">Create by</h5>

          <div className="row g-3 mb-5">
            {/* Package Name */}
            <div className="col-12 col-md-4">
              <label htmlFor="packageName" className="form-label text-muted">Package Name</label>
              <input type="text" className="form-control" id="packageName" defaultValue="Basic" />
            </div>

            {/* Currency */}
            <div className="col-12 col-md-4">
              <label htmlFor="currency" className="form-label text-muted">Currency</label>
              <select className="form-select" id="currency" defaultValue="INR">
                <option value="USD">$ USD</option>
                <option value="INR">₹ INR</option>
                <option value="EUR">€ EUR</option>
              </select>
            </div>  

            {/* Monthly Plan Rent */}
            <div className="col-12 col-md-4">
              <label htmlFor="monthlyRent" className="form-label text-muted">Monthly Plan Rent</label>
              <input type="text" className="form-control" id="monthlyRent" defaultValue="$ 999.00" />
            </div>

            {/* Annual Plan Rent */}
            <div className="col-12 col-md-4">
              <label htmlFor="annualRent" className="form-label text-muted">Annual Plan Rent</label>
              <input type="text" className="form-control" id="annualRent" defaultValue="$ 9,999.00" />
            </div>

            {/* GST Tax */}
            <div className="col-12 col-md-4">
              <label htmlFor="gstTax" className="form-label text-muted">GST Tax</label>
              <input type="text" className="form-control" id="gstTax" defaultValue="18%" />
            </div>

            {/* Discount */}
            <div className="col-12 col-md-4">
              <label htmlFor="discount" className="form-label text-muted">Discount</label>
              <input type="text" className="form-control" id="discount" defaultValue="$ 300" />
            </div>
          </div>

          {/* --- Module Selection Section --- */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold mb-0">Select Modules</h5>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" value="" id="selectAll" />
              <label className="form-check-label" htmlFor="selectAll">
                Select All
              </label>
            </div>
          </div>

          <div className="row">
            {/* Render the 5 columns of checkboxes */}
            {renderModuleColumns()}
          </div>

          {/* --- Action Buttons --- */}
          <hr className="my-4" />
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-light btn-lg me-3 focus-ring-0"
            >
              Clear
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-lg focus-ring-0"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CommonForm;
